
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CarePerson } from '@/commons/types/care'
import { ApplicantApplierRelationType } from '@/commons/constants/application'

@Component({
    computed: {
        ApplicantApplierRelationType () {
            return ApplicantApplierRelationType
        }
    }
})
export default class ParentInfo extends Vue {
    @Prop() parent!: CarePerson
}
